export const certificationData = [
  {
    id: 1,
    selectedstatus: false,
    certName: "ABR",
    fullForm: "Accredited Buyer's Representative",
    summary:
      "REALTORS® that have met strict educational and practical requirements set by the Real Estate Buyer's Agent Council (REBAC).",
    viewMore:
      "Look first for the Accredited Buyer’s Representative (ABR®) designation when looking for a home. REALTORS® with ABR® after their name have met strict educational and practical requirements set by the Real Estate Buyer’s Agent Council (REBAC) to help guide you in your successful home purchase.",
  },
  {
    id: 2,
    selectedstatus: false,
    certName: "AHWD",
    fullForm: "At Home With Diversity",
    summary:
      "Relays to the public that those certified have been professionally trained in and are sensitive to a wide range of cultural issues.",
    viewMore:
      "Relays to the public that those certified have been professionally trained in and are sensitive to a wide range of cultural issues.",
  },
  {
    id: 3,
    selectedstatus: false,
    certName: "ALC",
    fullForm: "Accredited Land Consultant",
    summary:
      "Experts in land brokerage transaction areas of five specialized types: (1) farms and ranches; (2) undeveloped tracts of land; (3) transitional land; (4) subdivision and wholesaling of lots; and (5) site selection and assemblage of land parcels.",
    viewMore:
      "Experts recognized in land brokerage transaction areas of five specialized types: (1) farms and ranches; (2) undeveloped tracts of land; (3) transitional land; (4) subdivision and wholesaling of lots; and (5) site selection and assemblage of land parcels.",
  },
  {
    id: 4,
    selectedstatus: false,
    certName: "BPOR",
    fullForm: "Broker Price Opinion Resource",
    summary:
      "Has the skill, technology and professional expertise to create accurate price opinions on properties.",
    viewMore:
      "The Broker Price Opinion Resource (BPOR) certification provides REALTORS® with knowledge and skills to create professional opinions of price. Creating accurate BPOs depends more than ever on professional expertise and competence, the best use of technology, and a commitment to approach the valuation assignment from all pertinent perspectives.",
  },
  {
    id: 5,
    selectedstatus: false,
    certName: "C2EX",
    fullForm: "Commitment to Excellence Endorsed",
    summary:
      "If you are considering buying or selling a home, work with a REALTOR® who has earned the Commitment to Excellence Endorsement (C2EX). C2EX indicates a REALTOR®'s commitment to achieving the highest level of professionalism in the business. The endorsement measures 10 aspects of professionalism, ranging from customer service to use of technology. The C2EX program evolves as industry standards and best practices evolve. REALTORS® who have earned their C2EX Endorsement are required to keep their skills and knowledge up to date.",
    viewMore:
      "If you are considering buying or selling a home, work with a REALTOR® who has earned the Commitment to Excellence Endorsement (C2EX). C2EX indicates a REALTOR®'s commitment to achieving the highest level of professionalism in the business. The endorsement measures 10 aspects of professionalism, ranging from customer service to use of technology. The C2EX program evolves as industry standards and best practices evolve. REALTORS® who have earned their C2EX Endorsement are required to keep their skills and knowledge up to date.",
  },
  {
    id: 6,
    selectedstatus: false,
    certName: "CCIM",
    fullForm: "Certified Commercial Investment Member",
    summary:
      "Expertise in commercial real estate brokerage, leasing, asset management valuation and investment analysis.",
    viewMore:
      "CCIMs are recognized experts in commercial real estate brokerage, leasing, asset management valuation and investment analysis. The CCIM business network includes more than 5,000 designees and 5,000 candidates principally in North America.",
  },
  {
    id: 7,
    selectedstatus: false,
    certName: "CIPS",
    fullForm: "Certified International Property Specialist",
    summary:
      "CIPS designees have demonstrated their international experience and participate in international programs offered by the National Association of REALTORS®.",
    viewMore:
      "Many REALTORS® work with buyers and sellers from different countries or cultures. CIPS designees have demonstrated their international experience and participate in international programs offered by the National Association of REALTORS®.",
  },
  {
    id: 8,
    selectedstatus: false,
    certName: "CPM",
    fullForm: "Certified Property Manager",
    summary:
      "CPM® members have the competitive edge in every area of real estate management from residential to commercial to industrial.",
    viewMore:
      "Acquire valuable real estate management skills through educational offerings leading to the CPM® designation. CPM® members have the competitive edge in every area of real estate management from residential to commercial to industrial.",
  },
  {
    id: 9,
    selectedstatus: false,
    certName: "CRB",
    fullForm: "Certified Real Estate Brokerage",
    summary:
      "Recognized throughout the industry as the professional peer organization for real estate's leaders.",
    viewMore:
      "When you work with a Certified Real Estate Brokerage Manager (CRB) or a firm managed by a CRB, you know your transaction will be handled with integrity, professionalism, and proven expertise. The CRB Designation exemplifies the highest level of professional achievement and recognition in real estate brokerage management. CRB Designees are proven leaders and are among the most efficient and effective managers in the industry.    ",
  },
  {
    id: 10,
    selectedstatus: false,
    certName: "CRE",
    fullForm: "Counselor of Real Estate",
    summary:
      "A member of an international group of recognized professionals who provide seasoned, objective advice on real property and land-related matters.",
    viewMore:
      "The Certified Real Estate Team Specialist certification is designed to improve team development, individual leadership skills, and financial performance (C-RETS). REALTORS® with the C-RETS Designation after their name have tools, strategies and knowledge that are required of today’s real estate professionals.    ",
  },
  {
    id: 11,
    selectedstatus: false,
    certName: "C-RETS",
    fullForm: "Certified Real Estate Team Specialist",
    summary:
      "The Certified Real Estate Team Specialist certification is designed to improve team development, individual leadership skills, and financial performance (C-RETS). REALTORS® with the C-RETS Designation after their name have tools, strategies and knowledge that are required of today’s real estate professionals.",
    viewMore:
      "The Certified Real Estate Team Specialist certification is designed to improve team development, individual leadership skills, and financial performance (C-RETS). REALTORS® with the C-RETS Designation after their name have tools, strategies and knowledge that are required of today’s real estate professionals.",
  },
  {
    id: 12,
    selectedstatus: false,
    certName: "CRS",
    fullForm: "Certified Residential Specialist",
    summary:
      "The highest designation awarded to sales associates, recognizing professional accomplishments in both experience and education.",
    viewMore:
      "The Certified Residential Specialist (CRS) is the highest Designation awarded to sales associates in the residential sales field. It recognizes professional accomplishments in both experience and education. CRS® Designees are experienced REALTORS® who complete advanced training in listing and selling, and meet rigorous production requirements.    ",
  },
  {
    id: 13,
    selectedstatus: false,
    certName: "EPRO",
    fullForm: "NAR's e-PRO®",
    summary:
      "Dedicated to making the most of today's technology to help with your real estate needs.",
    viewMore:
      "An agent with NAR's e-PRO® certification is dedicated to making the most of today's social media and technology to help you with your real estate needs, whatever they may be. e-PRO® is the only technology certification to be officially recognized, endorsed, and conferred by the National Association of REALTORS®.    ",
  },
  {
    id: 14,
    selectedstatus: false,
    certName: "GAA",
    fullForm: "General Accredited Appraiser",
    summary:
      "The designation is awarded to appraisers whose education and experience exceed state appraisal certification requirements.",
    viewMore:
      "Certified general appraisers wishing to increase their visibility should consider pursuing the GAA designation. The GAA designation is awarded to appraisers whose education and experience exceed state appraisal certification requirements and is supported by the National Association of REALTORS®.",
  },
  {
    id: 15,
    selectedstatus: false,
    certName: "GREEN",
    fullForm: "CNAR Green Designee",
    summary:
      "An NAR Green Designee is your trusted resource for understanding what makes a property green, listing green homes and guiding buyers interested in resource-efficient properties, discussing financial incentives, and understanding green industry rating systems. NAR’s Green Designation, awarded only after completion of strict educational and practical requirements, is the only one of its kind for REALTORS® recognized by NAR.",
    viewMore:
      "An NAR Green Designee is your trusted resource for understanding what makes a property green, listing green homes and guiding buyers interested in resource-efficient properties, discussing financial incentives, and understanding green industry rating systems. NAR’s Green Designation, awarded only after completion of strict educational and practical requirements, is the only one of its kind for REALTORS® recognized by NAR.",
  },
  {
    id: 16,
    selectedstatus: false,
    certName: "GRI",
    fullForm: "Graduate, REALTOR® Institute",
    summary:
      "An increased knowledge and skills in a broad array of technical subjects and the fundamentals of real estate.",
    viewMore:
      "Members primarily involved in residential real estate wanting to increase their knowledge and skills in a broad array of technical subjects and the fundamentals of real estate participate in the REALTOR® Institute, graduate program to earn the GRI designation. The program also provides opportunities to develop important business contacts. The GRI is a nationally recognized designation of the National Association of REALTORS®.",
  },
  {
    id: 17,
    selectedstatus: false,
    certName: "MRP",
    fullForm: "Military Relocation Professional",
    summary:
      "REALTORS® who earn the MRP (Military Relocation Professional) certification know how to work with military personnel and veterans to find housing solutions that best meet their needs.",
    viewMore:
      "REALTORS® who earn the MRP certification know how to work with military personnel and veterans to find housing solutions that best meet their needs and allow them to take full advantage of their military benefits.",
  },
  {
    id: 18,
    selectedstatus: false,
    certName: "PMN",
    fullForm: "Performance Management Network",
    summary:
      "Professionals who are business and community leaders, with expertise in performance management skills including negotiation, networking, and business planning.",
    viewMore:
      "Performance Management Network (PMN) Designees have the skills, the experience and the tools to keep them out front and on top of the changing and competitive real estate market. Earning the PMN requires a blend of coursework in real estate business skills and networking experience, a performance mix that builds their careers and elevates the level of service they are able to provide their clients.",
  },
  {
    id: 19,
    selectedstatus: false,
    certName: "PSA",
    fullForm: "Pricing Strategy Advisor",
    summary:
      "The certification is awarded to REALTORS® who have completed strict and educational training that gives REALTORS® skills in pricing properties, creating comparative market analysis, working with appraisers, and guiding clients through the anxieties and misperceptions they may have about home values.",
    viewMore:
      "The certification is awarded to REALTORS® who have completed strict and educational training that gives REALTORS® skills in pricing properties, creating comparative market analysis, working with appraisers, and guiding clients through the anxieties and misperceptions they may have about home values.",
  },
  {
    id: 20,
    selectedstatus: false,
    certName: "RAA",
    fullForm: "Residential Accredited Appraiser",
    summary:
      "This designation is awarded to appraisers whose education and experience exceed state appraisal certification requirements.",
    viewMore:
      "Certified residential appraisers wishing to increase their visibility should consider pursuing the RAA designation. The RAA designation is awarded to appraisers whose education and experience exceed state appraisal certification requirements and is supported by the Nations Association of REALTORS®.",
  },
  {
    id: 21,
    selectedstatus: false,
    certName: "RENE",
    fullForm: "Real Estate Negotiation Expert",
    summary:
      "The certification is awarded to REALTORS® who have completed strict and educational training that gives REALTORS® the tips and tools they need to be skillful advocates for their clients.",
    viewMore:
      "The certification is awarded to REALTORS® who have completed strict and educational training that gives REALTORS® the tips and tools they need to be skillful advocates for their clients.",
  },
  {
    id: 22,
    selectedstatus: false,
    certName: "RSPS",
    fullForm: "Resort & Second Home Property Specialist",
    summary: "REALTORS® specializing in the resort and second-home market.",
    viewMore:
      "REALTORS® specializing in the resort and second-home market. The certification is education-based and REALTORS® gain valuable knowledge to facilitate the buying, selling or management of properties for investment, development, retirement or second homes in a resort, recreational and/or vacation destination.",
  },
  {
    id: 23,
    selectedstatus: false,
    certName: "SFR",
    fullForm: "Short Sales & Foreclosure Resource (SFR)",
    summary:
      "Knows how to help sellers maneuver the complexities of short sales as well as help buyers pursue short sale and foreclosure opportunities.",
    viewMore:
      "REALTORS® who have earned the SFR certification know how to help sellers maneuver the complexities of short sales as well as help buyers pursue short sale and foreclosure opportunities. The certification program includes training on how to qualify sellers for short sales, negotiate with lenders, protect buyers, and limit risk.",
  },
  {
    id: 24,
    selectedstatus: false,
    certName: "SIOR",
    fullForm: "Society of Industrial and Office REALTORS®",
    summary:
      "Top producers in industrial and office real estate brokerage, representing more than 800 offices in over 350 cities worldwide.",
    viewMore:
      "Individuals certified with the SIOR designation are top producers in industrial and office real estate brokerage, representing more than 800 offices in over 350 cities worldwide. The Society’s mandatory recertification requirement assures clients of the designee’s excellence in the fast changing commercial brokerage field.",
  },
  {
    id: 25,
    selectedstatus: false,
    certName: "SRES",
    fullForm: "Seniors Real Estate Specialist",
    summary:
      "Knowledgeable on reverse mortgages, real estate planning, 1031 exchanges, and housing options and have been educated on all aspects of 50+ buying and selling.",
    viewMore:
      "A Seniors Real Estate Specialist® understands the demands of the mature market. These REALTORS® have a wealth of knowledge on reverse mortgages, real estate planning, 1031 exchanges, and housing options and have been educated on all aspects of 50+ buying and selling.",
  },
  {
    id: 26,
    selectedstatus: false,
    certName: "SRS",
    fullForm: "Seller Representative Specialist",
    summary:
      "If you are considering selling your home, work with a Seller Representative Specialist (SRS). REALTORS® with the SRS Designation after their name have met specific educational and practical experience criteria in representing sellers, and can to guide you through a successful transaction.",
    viewMore:
      "If you are considering selling your home, work with a Seller Representative Specialist (SRS). REALTORS® with the SRS Designation after their name have met specific educational and practical experience criteria in representing sellers, and can to guide you through a successful transaction.",
  },
  {
    id: 27,
    selectedstatus: false,
    certName: "CRETS",
    fullForm: "Certified Real Estate Team Specialist",
    summary:
      "The Certified Real Estate Team Specialist certification is designed to improve team development, individual leadership skills, and financial performance. The courses provide the tools, strategies, and knowledge that are required of today’s real estate professionals who are either considering or currently operating in a team environment. It is for team leaders, team members, those looking to start a team, and those who simply want to sharpen their management skills.",
    viewMore:
      "The Certified Real Estate Team Specialist certification is designed to improve team development, individual leadership skills, and financial performance. The courses provide the tools, strategies, and knowledge that are required of today’s real estate professionals who are either considering or currently operating in a team environment. It is for team leaders, team members, those looking to start a team, and those who simply want to sharpen their management skills.",
  },
  {
    id: 28,
    selectedstatus: false,
    certName: "GRN",
    fullForm: "NAR Green Designee",
    summary:
      "A resource for understanding what makes a property green, listing green homes and guiding buyers interested in resource-efficient properties, discussing financial incentives, and understanding green industry rating systems.",
    viewMore:
      "A resource for understanding what makes a property green, listing green homes and guiding buyers interested in resource-efficient properties, discussing financial incentives, and understanding green industry rating systems.",
  },
  {
    id: 29,
    selectedstatus: false,
    certName: "HFR",
    fullForm: "Home Finance Resource",
    summary:
      "REALTORS® who have specialized training in the loan origination process, navigating mortgage applications, and working with all types of buyers on alternative financing options.",
    viewMore:
      "REALTORS® who have specialized training in the loan origination process, navigating mortgage applications, and working with all types of buyers on alternative financing options.",
  },
];

export const certificationIconData = [
  {
    id: 1,
    selectedstatus: false,
    certName: "ABR",
    fullForm: "Accredited Buyer's Representative",
    summary:
      "REALTORS® that have met strict educational and practical requirements set by the Real Estate Buyer's Agent Council (REBAC).",
    viewMore:
      "Look first for the Accredited Buyer’s Representative (ABR®) designation when looking for a home. REALTORS® with ABR® after their name have met strict educational and practical requirements set by the Real Estate Buyer’s Agent Council (REBAC) to help guide you in your successful home purchase.",
  },
  {
    id: 2,
    selectedstatus: false,
    certName: "AHWD",
    fullForm: "At Home With Diversity",
    summary:
      "Relays to the public that those certified have been professionally trained in and are sensitive to a wide range of cultural issues.",
    viewMore:
      "Relays to the public that those certified have been professionally trained in and are sensitive to a wide range of cultural issues.",
  },
  {
    id: 3,
    selectedstatus: false,
    certName: "ALC",
    fullForm: "Accredited Land Consultant",
    summary:
      "Experts in land brokerage transaction areas of five specialized types: (1) farms and ranches; (2) undeveloped tracts of land; (3) transitional land; (4) subdivision and wholesaling of lots; and (5) site selection and assemblage of land parcels.",
    viewMore:
      "Experts recognized in land brokerage transaction areas of five specialized types: (1) farms and ranches; (2) undeveloped tracts of land; (3) transitional land; (4) subdivision and wholesaling of lots; and (5) site selection and assemblage of land parcels.",
  },
  {
    id: 4,
    selectedstatus: false,
    certName: "BPOR",
    fullForm: "Broker Price Opinion Resource",
    summary:
      "Has the skill, technology and professional expertise to create accurate price opinions on properties.",
    viewMore:
      "The Broker Price Opinion Resource (BPOR) certification provides REALTORS® with knowledge and skills to create professional opinions of price. Creating accurate BPOs depends more than ever on professional expertise and competence, the best use of technology, and a commitment to approach the valuation assignment from all pertinent perspectives.",
  },
  {
    id: 5,
    selectedstatus: false,
    certName: "C2EX",
    fullForm: "Commitment to Excellence Endorsed",
    summary:
      "If you are considering buying or selling a home, work with a REALTOR® who has earned the Commitment to Excellence Endorsement (C2EX). C2EX indicates a REALTOR®'s commitment to achieving the highest level of professionalism in the business. The endorsement measures 10 aspects of professionalism, ranging from customer service to use of technology. The C2EX program evolves as industry standards and best practices evolve. REALTORS® who have earned their C2EX Endorsement are required to keep their skills and knowledge up to date.",
    viewMore:
      "If you are considering buying or selling a home, work with a REALTOR® who has earned the Commitment to Excellence Endorsement (C2EX). C2EX indicates a REALTOR®'s commitment to achieving the highest level of professionalism in the business. The endorsement measures 10 aspects of professionalism, ranging from customer service to use of technology. The C2EX program evolves as industry standards and best practices evolve. REALTORS® who have earned their C2EX Endorsement are required to keep their skills and knowledge up to date.",
  },
  {
    id: 6,
    selectedstatus: false,
    certName: "CCIM",
    fullForm: "Certified Commercial Investment Member",
    summary:
      "Expertise in commercial real estate brokerage, leasing, asset management valuation and investment analysis.",
    viewMore:
      "CCIMs are recognized experts in commercial real estate brokerage, leasing, asset management valuation and investment analysis. The CCIM business network includes more than 5,000 designees and 5,000 candidates principally in North America.",
  },
  {
    id: 7,
    selectedstatus: false,
    certName: "CIPS",
    fullForm: "Certified International Property Specialist",
    summary:
      "CIPS designees have demonstrated their international experience and participate in international programs offered by the National Association of REALTORS®.",
    viewMore:
      "Many REALTORS® work with buyers and sellers from different countries or cultures. CIPS designees have demonstrated their international experience and participate in international programs offered by the National Association of REALTORS®.",
  },
  {
    id: 8,
    selectedstatus: false,
    certName: "CPM",
    fullForm: "Certified Property Manager",
    summary:
      "CPM® members have the competitive edge in every area of real estate management from residential to commercial to industrial.",
    viewMore:
      "Acquire valuable real estate management skills through educational offerings leading to the CPM® designation. CPM® members have the competitive edge in every area of real estate management from residential to commercial to industrial.",
  },
  {
    id: 9,
    selectedstatus: false,
    certName: "CRB",
    fullForm: "Certified Real Estate Brokerage",
    summary:
      "Recognized throughout the industry as the professional peer organization for real estate's leaders.",
    viewMore:
      "When you work with a Certified Real Estate Brokerage Manager (CRB) or a firm managed by a CRB, you know your transaction will be handled with integrity, professionalism, and proven expertise. The CRB Designation exemplifies the highest level of professional achievement and recognition in real estate brokerage management. CRB Designees are proven leaders and are among the most efficient and effective managers in the industry.    ",
  },
  {
    id: 10,
    selectedstatus: false,
    certName: "CRE",
    fullForm: "Counselor of Real Estate",
    summary:
      "A member of an international group of recognized professionals who provide seasoned, objective advice on real property and land-related matters.",
    viewMore:
      "The Certified Real Estate Team Specialist certification is designed to improve team development, individual leadership skills, and financial performance (C-RETS). REALTORS® with the C-RETS Designation after their name have tools, strategies and knowledge that are required of today’s real estate professionals.    ",
  },
  {
    id: 11,
    selectedstatus: false,
    certName: "CRETS",
    fullForm: "Certified Real Estate Team Specialist",
    summary:
      "The Certified Real Estate Team Specialist certification is designed to improve team development, individual leadership skills, and financial performance (C-RETS). REALTORS® with the C-RETS Designation after their name have tools, strategies and knowledge that are required of today’s real estate professionals.",
    viewMore:
      "The Certified Real Estate Team Specialist certification is designed to improve team development, individual leadership skills, and financial performance (C-RETS). REALTORS® with the C-RETS Designation after their name have tools, strategies and knowledge that are required of today’s real estate professionals.",
  },
  {
    id: 12,
    selectedstatus: false,
    certName: "CRS",
    fullForm: "Certified Residential Specialist",
    summary:
      "The highest designation awarded to sales associates, recognizing professional accomplishments in both experience and education.",
    viewMore:
      "The Certified Residential Specialist (CRS) is the highest Designation awarded to sales associates in the residential sales field. It recognizes professional accomplishments in both experience and education. CRS® Designees are experienced REALTORS® who complete advanced training in listing and selling, and meet rigorous production requirements.    ",
  },
  {
    id: 13,
    selectedstatus: false,
    certName: "e-PRO",
    fullForm: "NAR's e-PRO®",
    summary:
      "Dedicated to making the most of today's technology to help with your real estate needs.",
    viewMore:
      "An agent with NAR's e-PRO® certification is dedicated to making the most of today's social media and technology to help you with your real estate needs, whatever they may be. e-PRO® is the only technology certification to be officially recognized, endorsed, and conferred by the National Association of REALTORS®.    ",
  },
  {
    id: 14,
    selectedstatus: false,
    certName: "GAA",
    fullForm: "General Accredited Appraiser",
    summary:
      "The designation is awarded to appraisers whose education and experience exceed state appraisal certification requirements.",
    viewMore:
      "Certified general appraisers wishing to increase their visibility should consider pursuing the GAA designation. The GAA designation is awarded to appraisers whose education and experience exceed state appraisal certification requirements and is supported by the National Association of REALTORS®.",
  },
  {
    id: 15,
    selectedstatus: false,
    certName: "GRN",
    fullForm: "CNAR Green Designee",
    summary:
      "An NAR Green Designee is your trusted resource for understanding what makes a property green, listing green homes and guiding buyers interested in resource-efficient properties, discussing financial incentives, and understanding green industry rating systems. NAR’s Green Designation, awarded only after completion of strict educational and practical requirements, is the only one of its kind for REALTORS® recognized by NAR.",
    viewMore:
      "An NAR Green Designee is your trusted resource for understanding what makes a property green, listing green homes and guiding buyers interested in resource-efficient properties, discussing financial incentives, and understanding green industry rating systems. NAR’s Green Designation, awarded only after completion of strict educational and practical requirements, is the only one of its kind for REALTORS® recognized by NAR.",
  },
  {
    id: 16,
    selectedstatus: false,
    certName: "GRI",
    fullForm: "Graduate, REALTOR® Institute",
    summary:
      "An increased knowledge and skills in a broad array of technical subjects and the fundamentals of real estate.",
    viewMore:
      "Members primarily involved in residential real estate wanting to increase their knowledge and skills in a broad array of technical subjects and the fundamentals of real estate participate in the REALTOR® Institute, graduate program to earn the GRI designation. The program also provides opportunities to develop important business contacts. The GRI is a nationally recognized designation of the National Association of REALTORS®.",
  },
  {
    id: 27,
    selectedstatus: false,
    certName: "HFR",
    fullForm: "Home Finance Resource",
    summary:
      "REALTORS® who have specialized training in the loan origination process, navigating mortgage applications, and working with all types of buyers on alternative financing options.",
    viewMore:
      "REALTORS® who have specialized training in the loan origination process, navigating mortgage applications, and working with all types of buyers on alternative financing options.",
  },
  {
    id: 17,
    selectedstatus: false,
    certName: "MRP",
    fullForm: "Military Relocation Professional",
    summary:
      "REALTORS® who earn the MRP (Military Relocation Professional) certification know how to work with military personnel and veterans to find housing solutions that best meet their needs.",
    viewMore:
      "REALTORS® who earn the MRP certification know how to work with military personnel and veterans to find housing solutions that best meet their needs and allow them to take full advantage of their military benefits.",
  },
  {
    id: 18,
    selectedstatus: false,
    certName: "PMN",
    fullForm: "Performance Management Network",
    summary:
      "Professionals who are business and community leaders, with expertise in performance management skills including negotiation, networking, and business planning.",
    viewMore:
      "Performance Management Network (PMN) Designees have the skills, the experience and the tools to keep them out front and on top of the changing and competitive real estate market. Earning the PMN requires a blend of coursework in real estate business skills and networking experience, a performance mix that builds their careers and elevates the level of service they are able to provide their clients.",
  },
  {
    id: 19,
    selectedstatus: false,
    certName: "PSA",
    fullForm: "Pricing Strategy Advisor",
    summary:
      "The certification is awarded to REALTORS® who have completed strict and educational training that gives REALTORS® skills in pricing properties, creating comparative market analysis, working with appraisers, and guiding clients through the anxieties and misperceptions they may have about home values.",
    viewMore:
      "The certification is awarded to REALTORS® who have completed strict and educational training that gives REALTORS® skills in pricing properties, creating comparative market analysis, working with appraisers, and guiding clients through the anxieties and misperceptions they may have about home values.",
  },
  {
    id: 20,
    selectedstatus: false,
    certName: "RAA",
    fullForm: "Residential Accredited Appraiser",
    summary:
      "This designation is awarded to appraisers whose education and experience exceed state appraisal certification requirements.",
    viewMore:
      "Certified residential appraisers wishing to increase their visibility should consider pursuing the RAA designation. The RAA designation is awarded to appraisers whose education and experience exceed state appraisal certification requirements and is supported by the Nations Association of REALTORS®.",
  },
  {
    id: 21,
    selectedstatus: false,
    certName: "RENE",
    fullForm: "Real Estate Negotiation Expert",
    summary:
      "The certification is awarded to REALTORS® who have completed strict and educational training that gives REALTORS® the tips and tools they need to be skillful advocates for their clients.",
    viewMore:
      "The certification is awarded to REALTORS® who have completed strict and educational training that gives REALTORS® the tips and tools they need to be skillful advocates for their clients.",
  },
  {
    id: 22,
    selectedstatus: false,
    certName: "RSPS",
    fullForm: "Resort & Second Home Property Specialist",
    summary: "REALTORS® specializing in the resort and second-home market.",
    viewMore:
      "REALTORS® specializing in the resort and second-home market. The certification is education-based and REALTORS® gain valuable knowledge to facilitate the buying, selling or management of properties for investment, development, retirement or second homes in a resort, recreational and/or vacation destination.",
  },
  {
    id: 23,
    selectedstatus: false,
    certName: "SFR",
    fullForm: "Short Sales & Foreclosure Resource (SFR)",
    summary:
      "Knows how to help sellers maneuver the complexities of short sales as well as help buyers pursue short sale and foreclosure opportunities.",
    viewMore:
      "REALTORS® who have earned the SFR certification know how to help sellers maneuver the complexities of short sales as well as help buyers pursue short sale and foreclosure opportunities. The certification program includes training on how to qualify sellers for short sales, negotiate with lenders, protect buyers, and limit risk.",
  },
  {
    id: 24,
    selectedstatus: false,
    certName: "SIOR",
    fullForm: "Society of Industrial and Office REALTORS®",
    summary:
      "Top producers in industrial and office real estate brokerage, representing more than 800 offices in over 350 cities worldwide.",
    viewMore:
      "Individuals certified with the SIOR designation are top producers in industrial and office real estate brokerage, representing more than 800 offices in over 350 cities worldwide. The Society’s mandatory recertification requirement assures clients of the designee’s excellence in the fast changing commercial brokerage field.",
  },
  {
    id: 25,
    selectedstatus: false,
    certName: "SRES",
    fullForm: "Seniors Real Estate Specialist",
    summary:
      "Knowledgeable on reverse mortgages, real estate planning, 1031 exchanges, and housing options and have been educated on all aspects of 50+ buying and selling.",
    viewMore:
      "A Seniors Real Estate Specialist® understands the demands of the mature market. These REALTORS® have a wealth of knowledge on reverse mortgages, real estate planning, 1031 exchanges, and housing options and have been educated on all aspects of 50+ buying and selling.",
  },
  {
    id: 26,
    selectedstatus: false,
    certName: "SRS",
    fullForm: "Seller Representative Specialist",
    summary:
      "If you are considering selling your home, work with a Seller Representative Specialist (SRS). REALTORS® with the SRS Designation after their name have met specific educational and practical experience criteria in representing sellers, and can to guide you through a successful transaction.",
    viewMore:
      "If you are considering selling your home, work with a Seller Representative Specialist (SRS). REALTORS® with the SRS Designation after their name have met specific educational and practical experience criteria in representing sellers, and can to guide you through a successful transaction.",
  },
];
